/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs */

const en_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay calm. Stay sharp. Clarity for a steady mind.`)
};

const ar_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابق هادئًا. ابق يقظًا. وضوح لذهن ثابت.`)
};

const de_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewahre Ruhe. Bleibe scharfsinnig. Klarheit für einen gefestigten Geist.`)
};

const es_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantén la calma. Mantente agudo. Claridad para una mente estable.`)
};

const fr_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restez calme. Restez vif. La clarté pour un esprit stable.`)
};

const it_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantieni la calma. Resta lucido. Chiarezza per una mente stabile.`)
};

const ja_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冷静に、鋭敏に。揺るぎない心のための明晰さを。`)
};

const ko_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`침착하게, 예리하게. 흔들리지 않는 마음을 위한 명료함.`)
};

const pt_br_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mantenha a calma. Mantenha o foco. Clareza para uma mente estável.`)
};

const ru_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохраняйте спокойствие. Сохраняйте остроту ума. Ясность для устойчивого разума.`)
};

const th_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สงบ นิ่ง เฉียบคม ความชัดเจนเพื่อจิตใจที่มั่นคง`)
};

const tr_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sakin ol. Keskin kal. Dengeli bir zihin için berraklık.`)
};

const zh_cn_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`种一株冰雪聪明，收一份清醒好运。`)
};

const zh_tw_daily_paywall_exclusive_tree_ice_subtitle = /** @type {(inputs: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`種下冰雪聰明，收穫清晰好運。`)
};

/**
* | output |
* | --- |
* | "Stay calm. Stay sharp. Clarity for a steady mind." |
*
* @param {Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const daily_paywall_exclusive_tree_ice_subtitle = /** @type {((inputs?: Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Daily_Paywall_Exclusive_Tree_Ice_SubtitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "ar") return ar_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "de") return de_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "es") return es_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "fr") return fr_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "it") return it_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "ja") return ja_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "ko") return ko_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "pt_br") return pt_br_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "ru") return ru_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "th") return th_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "tr") return tr_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	if (locale === "zh_cn") return zh_cn_daily_paywall_exclusive_tree_ice_subtitle(inputs)
	return zh_tw_daily_paywall_exclusive_tree_ice_subtitle(inputs)
});